import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/home/footer_logo.png'
import _imports_1 from '@/assets/icons/icon_instagram_new.svg'
import _imports_2 from '@/assets/icons/icon_tiktok_new.svg'
import _imports_3 from '@/assets/icons/icon_linkedin_blue_new.svg'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-cont" }
const _hoisted_3 = { class: "sec-row-control site-container" }
const _hoisted_4 = { class: "row-section-cont" }
const _hoisted_5 = { class: "text-item" }

import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterBar',
  setup(__props) {

const router = useRouter();

const curYear = new Date().getFullYear();

const _goTOPrecdureIndex = () => {
    router.push({ path: "/procedure" });
};

const _goToDoctorIndex = () => {
    router.push({ path: "/doctor" });
};

const goContactUs = () => {
    router.push({ path: "/contactUs" });
};

const _handleBackHome = () => {
    if (router.currentRoute.value.name === "Home") {
        return;
    }
    router.push({ path: "/" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "sec-row-control logo-container" }, [
        _createElementVNode("div", {
          class: "logo-cont",
          onClick: _handleBackHome
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            class: "img",
            src: _imports_0
          }, null, -1),
          _createElementVNode("div", null, "Charm", -1)
        ]))
      ]),
      _createElementVNode("div", { class: "sec-row-control other-container" }, [
        _createElementVNode("div", { class: "row-section-cont" }, [
          _createElementVNode("div", { class: "sec-item-cont about-us" }, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "About us", -1)),
            _createElementVNode("div", {
              class: "about-item",
              onClick: _goTOPrecdureIndex
            }, " Procedures "),
            _createElementVNode("div", {
              class: "about-item",
              onClick: _goToDoctorIndex
            }, " Doctors ")
          ]),
          _createElementVNode("div", { class: "sec-item-cont contact-us" }, [
            _createElementVNode("div", {
              class: "title",
              onClick: goContactUs
            }, "Contact Us"),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "contact-item" }, [
              _createElementVNode("div", null, "9100 Wilshire Blvd, Beverly hills, CA 90212")
            ], -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "contact-item" }, [
              _createElementVNode("div", null, "support@charm-vibe.com")
            ], -1))
          ])
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"row-section-cont\" data-v-52f098b4><div class=\"follow-us\" data-v-52f098b4><div class=\"title\" data-v-52f098b4>Follow Us</div><div class=\"icon-cont\" data-v-52f098b4><div data-v-52f098b4><a href=\"https://www.instagram.com/charmvibeofficial/\" target=\"_blank\" data-v-52f098b4><img src=\"" + _imports_1 + "\" data-v-52f098b4></a></div><div data-v-52f098b4><a href=\"https://www.tiktok.com/@charmvibelv\" target=\"_blank\" data-v-52f098b4><img src=\"" + _imports_2 + "\" data-v-52f098b4></a></div><div data-v-52f098b4><a href=\"https://www.linkedin.com/company/charm-vibe/\" target=\"_blank\" data-v-52f098b4><img src=\"" + _imports_3 + "\" data-v-52f098b4></a></div></div></div></div>", 1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"row-section-cont\" data-v-52f098b4><a href=\"/termsservice\" target=\"_blank\" class=\"text-item\" data-v-52f098b4>Website Terms</a><a href=\"/privacypolicy\" target=\"_blank\" class=\"text-item\" data-v-52f098b4>Privacy Policy</a><span class=\"text-item\" data-v-52f098b4>Accessibility Statement</span><span class=\"text-item\" data-v-52f098b4>AHPRA Advertising Disclaimer</span><span class=\"text-item\" data-v-52f098b4>Supplier Code of Conduct</span></div><div class=\"row-section-cont\" data-v-52f098b4><span class=\"text-item\" data-v-52f098b4>Cookie Preferences</span><span class=\"text-item\" data-v-52f098b4>Do Not Sell My Personal Information</span><span class=\"text-item\" data-v-52f098b4>Modern Slavery Statement</span></div><div class=\"row-section-cont\" data-v-52f098b4><span class=\"text-item\" data-v-52f098b4>Charm-Vibe™ — Empowering Confidence. Supporting Communities.</span></div>", 3)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, "© " + _toDisplayString(_unref(curYear)) + " Charm-Vibe. All Rights Reserved.", 1)
        ])
      ])
    ])
  ]))
}
}

})